import { useState, useRef, useEffect } from "react";
import styles from "./emojipicker.module.css";

const EMOJIS = [
    // Pessoas / RH
    "👥","👤","🤝","👔","🧑‍💼","👨‍💼","👩‍💼","🪪","🎓","🧑‍🏫",
    // Comunicação
    "📢","📣","💬","📱","📞","📧","✉️","📨","📩","🗣️",
    // Documentos
    "📄","📋","📁","📂","📝","📊","📈","📉","🗂️","📑",
    // Ferramentas / Config
    "⚙️","🔧","🛠️","🔑","🔒","🔓","🔗","🖥️","💻","🖨️",
    // Financeiro
    "💰","💵","💳","🏦","💱","🧾","📤","📥",
    // Saúde / Benefícios
    "🏥","❤️","✅","💊","🩺","🏋️","🩹","🧬",
    // Calendário / Tempo
    "📅","📆","🗓️","⏰","⏱️","🕐","🗒️",
    // Local / Empresa
    "🏢","🏠","📍","🌐","🗺️","🏭","🏪",
    // Destaque / Qualidade
    "⭐","🌟","🏆","🎯","✨","🚀","🎖️","🥇","🔥",
    // Navegação / Geral
    "ℹ️","❓","❗","📌","🎉","🆕","➡️","🔔","🛡️","📎",
];

export default function EmojiPicker({ value, onChange }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        function onOutside(e) {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        }
        if (open) document.addEventListener("mousedown", onOutside);
        return () => document.removeEventListener("mousedown", onOutside);
    }, [open]);

    return (
        <div className={styles.wrapper} ref={ref}>
            <div className={styles.inputRow}>
                <input
                    className={styles.input}
                    value={value}
                    onChange={e => onChange(e.target.value)}
                    placeholder="😊"
                    maxLength={4}
                />
                <button
                    type="button"
                    className={`${styles.trigger} ${open ? styles.triggerAtivo : ""}`}
                    onClick={() => setOpen(o => !o)}
                    title="Escolher emoji"
                >
                    {value || "😊"}
                </button>
            </div>

            {open && (
                <div className={styles.picker}>
                    <div className={styles.pickerHeader}>Escolha um ícone</div>
                    <div className={styles.grid}>
                        {EMOJIS.map(em => (
                            <button
                                key={em}
                                type="button"
                                className={`${styles.emojiBtn} ${value === em ? styles.selected : ""}`}
                                onClick={() => { onChange(em); setOpen(false); }}
                            >
                                {em}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
